import { useI18n } from '#/i18n/hooks/useI18n';
import { useSearchFacetsJob } from '#/modules/search/constants/useSearchFacetsJob';
import { useSearchQuery } from '#/modules/search/contexts/SearchContext';
import { SearchPage } from '#/modules/search/pages/Search/SearchPage';

export function SearchJobsPage() {
  const { i18n } = useI18n();

  const query = useSearchQuery();

  const { jobSearchFacets } = useSearchFacetsJob(i18n);

  return (
    <SearchPage
      searchFacets={jobSearchFacets}
      searchType="JOB"
      showSortOptions={Boolean(query)}
    />
  );
}
